import { ModelType } from '@dashboard/shared-constants/pricing/constants';
export let SetupDiscountStepNames = /*#__PURE__*/function (SetupDiscountStepNames) {
  SetupDiscountStepNames["CREATE_DISCOUNT"] = "CREATE_DISCOUNT";
  SetupDiscountStepNames["ADD_DETAILS"] = "ADD_DETAILS";
  SetupDiscountStepNames["SAVE_DISCOUNT"] = "SAVE_DISCOUNT";
  return SetupDiscountStepNames;
}({});
export const WalkthroughDataAttrValues = {
  [ModelType.DISCOUNT]: {
    nameField: 'discount-name',
    saveButton: 'discount-save'
  },
  // No walkthrough for service charges
  [ModelType.SURCHARGE]: {}
};